import { Briefcase, Code2 } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Profile {
  title: string;
  assessmentType: string;
  dimensions: string[];
  icon: LucideIcon;
}

const profiles: Profile[] = [
  {
    title: 'Líderes de Produto, Growth e Negócios',
    assessmentType: 'Governança de Produtos',
    dimensions: [
      'Clareza de visão e priorização',
      'Alinhamento entre times',
      'Processos de discovery e delivery',
    ],
    icon: Briefcase,
  },
  {
    title: 'Líderes de Tecnologia e Engenharia',
    assessmentType: 'Performance da Operação Tech',
    dimensions: [
      'Eficiência do ciclo de desenvolvimento',
      'Qualidade técnica e débito',
      'Capacidade real de resposta da operação',
    ],
    icon: Code2,
  },
];

export function TargetAudience() {
  return (
    <section
      className="py-24 px-4 sm:px-8 lg:px-16 border-t border-border"
      aria-labelledby="audience-heading"
    >
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary text-sm font-medium uppercase tracking-widest">
            Público
          </span>
          <h2 id="audience-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            Para quem este review faz sentido?
          </h2>
        </div>

        {/* Profiles */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {profiles.map((profile) => (
            <div
              key={profile.title}
              className="group p-8 rounded-2xl border border-border bg-card hover:border-primary/30 transition-colors"
            >
              {/* Header */}
              <div className="flex items-start gap-4 mb-6">
                <div className="p-3 rounded-xl bg-primary/10">
                  <profile.icon className="h-7 w-7 text-primary" aria-hidden="true" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold mb-2">{profile.title}</h3>
                  <span className="inline-block px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium">
                    {profile.assessmentType}
                  </span>
                </div>
              </div>

              {/* Dimensions */}
              <div className="space-y-4">
                <p className="text-xs font-medium text-muted-foreground uppercase tracking-widest">
                  Dimensões avaliadas
                </p>
                <ul className="space-y-3">
                  {profile.dimensions.map((dimension) => (
                    <li key={dimension} className="flex items-start gap-3">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
                      <span className="text-muted-foreground">{dimension}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
